import React, { Component } from "react";
import "./Home.css";
import {  ListGroup ,ListGroupItem ,ButtonGroup ,Button,Jumbotron,FormGroup,ControlLabel,FormControl,Table,Col,Form,Checkbox} from "react-bootstrap";
import { API } from "aws-amplify";

import AUTHMD from '../md/HomeAuthenticated.md'
import UNAUTHMD from '../md/HomeUnAuthenticated.md'
import LoaderButton from "../components/LoaderButton";
import ReactMarkdown from 'react-markdown/with-html'

import Moment from 'react-moment';
import moment from "moment"
function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}



export default class AdminUsers extends Component {
    constructor(props) {
      super(props);
      this.state = {
          myaltioms:[],
          myaltioms_fetching:true,
          markdown:"",
          branch_name:"",
          branch_id:this.props.match.params.id,
          branch_type:"normal",
          permission_data:JSON.stringify({}),
          permission_max_count:0,
          permission_date:"",
          newUser:false,
          responce:"",
          data:"{}",
          enabled:true,
          expiry:"",
          count:"-",
          max_count:0,
          sortmode:"name",
          sortmodereverse:true,
          isLoading:true,
          isSuper:false,
          isNew:false,
          data:[]
      };
    }

    async componentWillMount() {
      //const data = await this.getInfo();
      //console.log(data)
      //this.setState(data)
      //console.log(this.state)
      let data=await this.getAdmin({admin:true,type:"code",cmd:"getcode" ,id:this.props.match.params.id})

      console.log(data)

      if(data=="Invalid"){
        this.setState({isNew:true})
        this.setState({isLoading:false})
        this.setState({isSuper:true})
        return;
      }
      if("newUser" in data){
          //not an admin!

      }
      else{
        this.setState({isSuper:true})
        this.setState({permission_data:data.data})
        if ("expiry"  in data){
          this.setState({permission_date:data.expiry})

        }
        console.log(data)
        this.setState(data)

      }
          this.setState({isLoading:false})

    }

    whatType(d){
      console.log("Type")
      console.log(d)
      if("temp" in d){
        if(d.temp==true)
          return "temp"
      }
      if("sms" in d){
        if(d["sms"]==true)
          return "sms"
      }
      return "normal"


    }


    getAdmin(data){
      let getdata = {
        'queryStringParameters': data
      }
      return API.get("AltiomData", "/welcome",getdata);
    }

    hightlightSort(d){

      if(d==this.state.sortmode){
        return "bolder"
      }
      return ""


    }

    hightlightName(d){
      if(d==this.state.branch_name){
        return "red"
      }
      return ""


    }

    data_sort=(a,b)=>{

      let sA=a[this.state.sortmode]
      let sB=b[this.state.sortmode]
      if(this.state.sortmode=="date"){
        sA=a.date.$date
        sB=b.date.$date
      }

      if(this.state.sortmode=="Username"){
        sA=a.Attributes[2].Value.toLowerCase()
        sB=b.Attributes[2].Value.toLowerCase()
      }


      if(sA<sB){
        if(this.state.sortmodereverse==true)
          return 1
        return -1
      }
      if(sA>sB){
        if(this.state.sortmodereverse==true)
          return -1
        return 1
      }
      return 0
    }

    changeSort=(key)=>{
      console.log(key)
      if(key==this.state.sortmode){
        console.log(this.state.sortmodereverse)
        this.setState({sortmodereverse:!this.state.sortmodereverse})
      }
      this.setState({sortmode:key})
    }

mode=(d)=>{

  if(d.temp==true){
    return "Temperature"
  }
  if(d.sms==true){
    return "SMS"
  }
  return "Normal"
}

generateUID=()=>{
  let id=guid()
  this.setState({branch_id:id})
}

namechange=(e)=>{

  this.setState({permission_data:e.target.value})
}

max_countChange=(e)=>{
  this.setState({permission_max_count:e.target.value})
}

dateChange=(e)=>{

  this.setState({permission_date:e.target.value})
}


typechange=(e)=>{

  this.setState({branch_type:e.target.value})
}




updateCode=async ()=>{
  console.log("Update a permission code")



  if(this.state.permission_data.length==0){
    alert("Must provide permission data")
    return
  }

  let temp=this.state.permission_data
  try{
    let parsed=JSON.parse(temp)
    console.log(Object.keys(parsed).length)
    if(Object.keys(parsed).length==0){
      alert("Need atleast one permission key")
      return
    }
  }
  catch(err){
    alert("Not Valid permission data")
    return
  }




  let d={ "id":this.props.match.params.id,
          "data":JSON.stringify(JSON.parse(this.state.permission_data)),
          "expiry":this.state.permission_date,
          "max_count":parseInt(this.state.permission_max_count),
          "enabled":true
  }

  console.log(d)
  let data=await this.getAdmin({admin:true,type:"code",cmd:"setCode",data:JSON.stringify(d)})
  console.log("Response")
  console.log(data)
  this.setState(data)
  console.log(this.state.max_count)
this.setState({permission_data:data.data})
  this.setState({isNew:false})
  //this.setState({branch_id:""})



}

enable=async ()=>{
let data=await this.getAdmin({admin:true,type:"code",cmd:"enableCode",id:this.props.match.params.id})
this.setState(data)

}

disable=async ()=>{
let data=await this.getAdmin({admin:true,type:"code",cmd:"disableCode",id:this.props.match.params.id})
this.setState(data)
}




    render() {
      return (
          <div className="Home">
          <Jumbotron>
            <h2><a href="/admin">Admin</a> > <a href="/admin/codes">Codes</a> </h2>


            {/* Need to make this pagnate and search as number of users increases */}
            <hr/>
            {this.state.isSuper==true ? (
              <div>
              {this.state.isNew ?(<h2>New</h2>):(<div>



                  <b>Max count:</b> {this.state.max_count}        <br/>
                  <b>Current count:</b> {this.state.count}        <br/>
                  <b>Expiry:</b>   {this.state.expiry}      <br/>
                  <b>Enabled:</b>   {this.state.enabled.toString()}      <br/>


                  <br/>
                  URL
                  <input type="text" value={"https://cloud.altiom.link/auth/"+this.state.branch_id}></input>



                  <Button  onClick={()=>this.enable()}>Enable</Button>
                  <Button  onClick={()=>this.disable()}>Disable</Button>
                  <hr/>




                </div>)}
              <h3>Code Settings</h3>
              <Form horizontal>
              <FormGroup controlId="formHorizontalEmail">
                <Col componentClass={ControlLabel} sm={2}>
                  Code
                </Col>
                <Col sm={10}>
                  <FormControl type="text" value={this.state.branch_id} placeholder="Unique id" disabled/>
                  <i>This cannont be changed once set. cAse sENsItIVE!</i>
                </Col>
              </FormGroup>
              <hr/>
              <FormGroup controlId="formHorizontalPassword">
                <Col componentClass={ControlLabel} sm={2}>
                  Max uses
                </Col>
                <Col sm={10}>
                <FormControl type="number" min={0} max={999999} value={this.state.permission_max_count} onChange={(e)=>this.max_countChange(e)}  placeholder="Max uses" />
                <i>Set to 0 for infinite</i>
                </Col>
              </FormGroup>
              <FormGroup controlId="formHorizontalPassword">
                <Col componentClass={ControlLabel} sm={2}>
                  Expiry
                </Col>
                <Col sm={10}>
                <FormControl type="date" min={0} max={999999} value={this.state.permission_date} onChange={(e)=>this.dateChange(e)} placeholder="Expiry" />
                <i>Code will stop working on this day</i>
                </Col>
              </FormGroup>
              <FormGroup controlId="formHorizontalPassword">
                <Col componentClass={ControlLabel} sm={2}>
                  permission_code
                </Col>
                <Col sm={10}>
                <FormControl  componentClass="textarea" placeholder="textarea" type="textarea" value={this.state.permission_data} onChange={(e)=>this.namechange(e)} placeholder="permission data" />
                <i>This is the raw JSON permissions. An interface may be created for this in future</i>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col smOffset={2} sm={10}>
                  <Button onClick={()=>this.updateCode()}>Update</Button>
                </Col>
              </FormGroup>
            </Form>

</div>):(<div>
{this.state.isLoading==true ? (<p>Loading</p>):(<p>No Data for you</p>)}
              </div>
)}









            </Jumbotron>
          </div>
        );
    }
}

//{this.props.isAuthenticated ? <ReactMarkdown className="CenterText" source={this.state.md_auth}  escapeHtml={false} /> : <ReactMarkdown className="CenterText" source={this.state.md_unauth}  escapeHtml={false}/>}



// WEBPACK FOOTER //
// ./src/containers/AdminCodeRef.js